import { Svg } from '@/components/foundation/Svg'
import { classes } from '@lc/libreact'
import { safeProp } from '@lc/libutils'
import { type JSX } from 'react'
import styles from './Title.scss'

type TitleLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

type TitleProps = {
	className?: string
	title: string
	level: TitleLevel
	picto?: string
	color: 'light' | 'primary' | 'black'
	style?: {
		fontSize?: string
	}
}

export function Title({ className, title, level, picto, color }: TitleProps) {
	const Tag = level as keyof JSX.IntrinsicElements
	return (
		<div className={className}>
			{picto && (
				<Svg
					className={styles.pictoTitle}
					url={picto}
					bounds={{ x: 0, y: 0, width: 14, height: 15 }}
				/>
			)}
			<Tag
				className={classes(
					styles[safeProp(level)],
					styles[safeProp(color)],
				)}
			>
				{title}
			</Tag>
		</div>
	)
}
